import React from "react";
import {useNavigate} from "react-router-dom";
import {useAuth} from "context/AuthContext";
import Spinner from "components/Spinner";
import Avatar from "components/Avatar";
import {useMutation} from "react-query";
import {useNotifications} from "../../context/NotificationContext";
import {LogoutIcon} from "../Icon/ngage";

function CurrentUser() {
    const navigate = useNavigate();
    const auth = useAuth();
    const {notify} = useNotifications();

    const {mutate, isLoading} = useMutation(auth.logout, {
        onSuccess: () => navigate('/'),
        onError: () => notify("error", "Logout failed", "Sorry, we couldn't log you out. Please try again."),
    })

    function editProfile() {
        navigate('/user-settings');
    }

    function logout() {
        mutate();
    }

    if (!auth.user) {
        return (
            <div className="flex-shrink-0 flex bg-white p-4">
                <p className="text-sm font-medium text-gray-600">Unknown User</p>
            </div>
        )
    }

    return (
        <div className="flex-shrink-0 flex bg-white py-4 mx-4 border-t border-gray-200">
            <div className="flex-shrink-0 w-full group flex justify-between">
                <button onClick={editProfile} className="flex items-center flex-1">
                    <div>
                        <Avatar size={Avatar.sizes.MEDIUM} src={auth.user.profile_picture?.preview_url ?? auth.user.profile_photo_url}
                                alt={auth.user.name}/>
                    </div>
                    <div className="ml-3 text-left">
                        <p className="text-sm font-medium text-gray-900">{auth.user?.name}</p>
                        <p className="text-xs font-medium text-gray-500">User Settings</p>
                    </div>
                </button>
                <button onClick={logout} disabled={isLoading}>
                    {isLoading ?
                        <div className='pr-2'>
                          <Spinner color={Spinner.colors.DARK} size={Spinner.sizes.X_SMALL}/>
                        </div> :
                        <LogoutIcon className="flex-shrink-0 h-6 w-6 text-gray-500 hover:text-gray-600 group/logout"/>}
                </button>
            </div>
        </div>
    );
}

export default CurrentUser;